import React from "react";
import {
  breakpointClasses,
  cls,
  cn,
  resolveElement,
  splitBreakpointProps,
} from "@/lib/utils";
import type { TypographyH4Props } from "../types";

function TypographyH4({ as, asChild, className, ...props }: TypographyH4Props) {
  const Component = resolveElement(asChild, as, "h4");
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Typography.H4] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Component
      className={cn(
        cls`
          scroll-m-20
          ~text-sm/lg
          leading-snug lg:leading-[1.4]
          font-header font-bold
          uppercase tracking-wide
        `,
        className,
        classes,
      )}
      {...native}
    />
  );
}

export default TypographyH4;
